import { Component, Input } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { LocationService } from '../../services/location.service';
import { IFulfillmentStatus, IOrder, IOrderItem, SaleService } from '../../services/sale.service';
import { MatDialog } from '@angular/material/dialog';
import { CancelOrderPopupComponent } from "../cancel-order-popup/cancel-order-popup.component";
import { OrderService } from "../../services/order.service";
import { MsAuthService } from "../../services/ms-auth.service";
import { MatSnackBar } from "@angular/material/snack-bar";
import { Observable } from "rxjs";
import { IDataPair } from "../../shared/models/data-pair.model";
import { LoadingService } from "../../services/loading.service";
import { ErrorService } from "../../services/error.service";

export interface ICancelResponse {
  type: string;
  id?: string;
  status: string;
}


@Component({
  selector: 'order-detail',
  templateUrl: './order-detail.component.html',
  styleUrls: ['./order-detail.component.scss'],
})
export class OrderDetailComponent {
  @Input() order: IOrder | undefined;
  @Input() item: IOrderItem | undefined;
  @Input() original = true;
  constructor(
    private _locationService: LocationService,
    private _translate: TranslateService,
    private _dialog: MatDialog,
    private _orderService: OrderService,
    private _msAuthService: MsAuthService,
    private _snackBar: MatSnackBar,
    private _saleService: SaleService,
    private _loadingService: LoadingService,
    private _errorService:ErrorService
    ) {
  }

  public get initiatingStore(): string {
    if (this.order) {
      if (this.order.initiatingStore !== '') {
        return `${this.order.initiatingStore} ${
          this._locationService.stores.find(
            (store) => store.id === this.order.initiatingStore
          )?.name || ''
        }`;
      } else if (!this.order.isRetail) {
        return this._translate.instant('orderDetail.online');
      } else {
        return '';
      }
    } else {
      return '';
    }
  }
  
  public get pickupStore(): string {
    if (this.order && this.order.pickupStore !== '') {
      return `${this.order.pickupStore} ${
        this._locationService.stores.find(
          (store) => store.id == this.order.pickupStore
        )?.name || ''
      }`;
    } else {
      return '';
    }
  }
  
  public cancelOrderClicked() {
    let dialogRef = this.promptForCancel();
    
    dialogRef.subscribe((reasonCode:IDataPair) => {
        const employeeEmail = this._msAuthService.getAccountEmail();
        
        if(employeeEmail && reasonCode) {
          let orderReasonCode:string = reasonCode.value.toString().slice(0,4);
          this._loadingService.startLoading();
          
          this._orderService.holdEntireOrder(this.order.orderId,employeeEmail, this.order,orderReasonCode)
            .subscribe((result:ICancelResponse) => {
              if(result && result.status === 'ok'){
                this._loadingService.stopLoading();
                this.order.status = this._translate.instant('order.cancelled');
                this.order.items.map(item => {
                  item.status = this._translate.instant('item.cancelled');
                  
                  let unknown:IFulfillmentStatus; //hold status
                  let cancelled:IFulfillmentStatus;
                  item.history.map((fulfillmentStatus) => {
                    cancelled = {
                      ...fulfillmentStatus,
                      statusCode: '5',
                      statusName: this._translate.instant('item.cancelled'),
                      userId: this.order.email,
                      sequence: 3,
                      timestamp: new Date().toISOString()
                    }
                    unknown = {
                      ...fulfillmentStatus,
                      statusCode: '17',
                      statusName: this._translate.instant('item.unknown'),
                      sequence: 2,
                      userId: this.order.email,
                      timestamp: new Date().toISOString()}
                  })
                  item.history = [cancelled,unknown,...item.history];
                });
                this._snackBar.open(
                  this._translate.instant('order.successCancelOrder'),
                  'OK',
                  { duration: 5000 })
              }
            }, (e) => {
              this._loadingService.stopLoading();
              e.error.errors[0].message.includes('hold') ?
              this._errorService.showError(this._translate.instant('errors.hold')) : this._errorService.showGeneralError(true);
              throw e;
            })
        }
    });
  }

  private promptForCancel(): Observable<any> {
    return this._dialog.open(CancelOrderPopupComponent, {
      data: {
        order: this.order
      }
    }).afterClosed();
  }
  
  public isUnprocessed(): boolean {
    return (this.order && this.order.status === 'order.unprocessed' && this.order.type === 'ECOMMORDER' &&
      this.order.deliveryBlock !== 'Z1' && !this.order.serviceLevel.includes('intl') &&
      (this.order.orderType === 'order.ecomDelivery' || this.order.orderType === 'order.ecomPickup')
    )
  }
  
  public isFraud(): boolean {
    return this.order && this.order.status === 'order.unprocessed' && this.order.deliveryBlock === 'Z1'; // flag for fraud
  }
  
  public isIntlUnprocessed(): boolean {
    return this.order && this.order.status === 'order.unprocessed' && this.order.type === 'ECOMMORDER'
      && this.order.deliveryBlock !== 'Z1' && this.order.serviceLevel.includes('intl')
  }
  
  public isCancellationClosed(): boolean {
    return this.order && this.order.type === 'ECOMMORDER' && this.order.deliveryBlock !== 'Z1'
      && this.order.serviceLevel.includes('intl') &&
      !(this.order.status === 'order.unprocessed' || this.order.status === 'order.complete' ||
        this.order.status === 'order.unfulfillable' || this.order.status === 'order.cancelled') &&
      this.order.orderType !=='eComm Credit Memo' && this.order.orderType !=='eComm Order Return - DC'
  }
  
  public isConcierge(): boolean {
    return this._msAuthService.isConcierge();
  }
  
  public isRetailTransactionReturn(): boolean {
    return this.order.type == 'RETAILTRANSACTION' && !this.original;
  }
  
  public getSource(source: string): string {
    return this._orderService.getSource(source);
  }
}
